// api/user-api.js

import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_LINK || "http://localhost:8000";

export const getAllUser = async () => {
  try {
    const res = await axios.get(`http://localhost:8000/api/adminUsers` );
    return res.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const res = await axios.post(`${API_URL}/adminUsers/create`, userData);
    return res.data?.payload;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const getUserById = async (userId) => {
  try {
    const res = await axios.get(`${API_URL}/adminUsers/${userId}`);
    return res.data?.payload;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

export const updateUser = async (userId, updatedData) => {
  try {
    const res = await axios.patch(`http://localhost:8000/api/adminUsers/${userId}`, updatedData);
    return res.data?.payload;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const res = await axios.delete(`http://localhost:8000/api/adminUsers/${userId}`); 
    return res.data?.payload;
  } catch (error) {
    console.error(`Error deleting user with ID ${userId}:`, error.message || error);
    throw error;
  }
};


